// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ExternalLink: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 53"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M45.1 21.8c-.8 0-1.4.6-1.4 1.4v26.5H3.3V9.3h26.5c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H3.3C1.8 6.5.5 7.8.5 9.3v40.4c0 1.5 1.3 2.8 2.8 2.8h40.4c1.5 0 2.8-1.3 2.8-2.8V23.2c0-.8-.6-1.4-1.4-1.4z"/><path d="M52.5 1.8c-.1-.7-.7-1.2-1.4-1.2H39.9c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h7.8L29.5 21.5c-.3.3-.4.6-.4 1 0 .3.2.8.5 1 .3.3.6.4.9.4.3 0 .8-.2 1-.5L49.7 5.3v7.8c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4V1.8z"/></svg>;
};

export default React.memo(ExternalLink);
